import { render, staticRenderFns } from "./ProgressMultipleBar.vue?vue&type=template&id=6023597d"
import script from "./ProgressMultipleBar.vue?vue&type=script&lang=js"
export * from "./ProgressMultipleBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports